import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {store} from 'base/reducers';
import CONFIG from 'base/constants/config';
import {UploadImage} from 'components/UI/Image';
import {HighlightBusinesses} from 'api';
import {connect} from 'react-redux';

class HighlightBusinessBox extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleDelete = this.handleDelete.bind(this);
    this.goEdit = this.goEdit.bind(this);

  }

  handleDelete() {
    const id = this.props.data && this.props.data.id;
    if (!id) {
      return;
    }
    if (confirm("Bạn có muốn xóa banner này không?")) {
      HighlightBusinesses.actions.delete.request({id}).then(response => {
        // this.props.dispatch({
        //   type: 'REMOVE_HOME_BANNER',
        //   homeBannerId: id
        // });
        location.reload();
      });
    }
  }

  goEdit() {
    const id = this.props.data && this.props.data.id;
    if (!id) {
      return;
    }
    this.props.history.push(`/highlight-businesses/edit/${id}`);
  }

  render() {
    let Img = null;
    if (this.props.data && this.props.data.banner) {
      Img = <UploadImage width={545} height={300} type='HIGHLIGHT_BUSINESS' image={this.props.data.banner} transform='crop' className="image"/>
    } else {
      Img = <img className="media-object image" src={require('assets/images/placeholder-128.jpg')} alt="..." width="250" height="250"/>;
    }

    return (
      <div className="home-banner-wrap col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div className="box-image">
          {Img}
        </div>
        <div className="box-content">
          <h4 className="heading-4">
            <a href={this.props.data.link} target="_blank" title={this.props.data.link} className="banner-link">{this.props.data.link}</a>
          </h4>
        </div>
        <div className="box-action">
          <button className="btn btn-default" onClick={this.goEdit}>Sửa</button>
          <button className="btn btn-danger" onClick={this.handleDelete}>Xóa</button>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(HighlightBusinessBox));



// WEBPACK FOOTER //
// ./components/highlight-businesses/HighlightBusinessBox.jsx